import React from 'react';
import { Tooltip, LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';


const LineAcessos = ({data, colors, title}) => {



return(<>
            <h4>{title}</h4>
            <ResponsiveContainer width="100%" height={200}>
              <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Line type="monotone" dataKey="acessos" stroke={colors[1]} />
                <Line type="monotone" dataKey="tentativas" stroke={colors[3]} strokeDasharray={"5 5"} />
              </LineChart>
            </ResponsiveContainer>
</>)

}

export default LineAcessos
